import styled from "@emotion/styled";
import colors from "styles/colors";
import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledDirectoryHeaderComponent = styled.div`
  position: relative;

  img {
    height: 100%;
  }

  .header-text {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    h1 {
      font-size: 5vw;
      color: ${colors["white"]};
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    img {
      height: 70%;
    }

    .header-text {
      h1 {
        font-size: 4.5rem;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    img {
      display: none;
    }

    .header-text {
      h1 {
        font-size: 3.375rem;
      }
    }
  }
`;
